var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('message-bubble',{attrs:{"isMine":_vm.isMine}},[[_c('span',[_vm._v("[暂未支持的消息类型]")])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }